import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Column } from 'foundations-components/transitional/components/Column';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm-... Remove this comment to see the full error message
import links from 'crm-legacy-links/links';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import PermissionTooltip from 'customer-data-objects-ui-components/permissions/PermissionTooltip';
import { ObjectTypeFromIds } from 'customer-data-objects/constants/ObjectTypeIds';
import { useObjectLimitAndTotal } from '../../crmObjects/hooks/useObjectLimitAndTotal';
import { useShouldShowImportEmptyStateModal } from '../../experiments/hooks/emptyStateHooks';
import { redirectTo } from '../../experiments/utils/url';
import { useModalActions } from '../../overlay/hooks/useModalActions';
import { trackClickedEmptyStateWelcomeModal } from '../../tracking/indexPageTracking';
import { IMPORT, useLimitUpgradeButtonProps } from '../../upgrades/hooks/useLimitUpgradeButtonProps';
import { useCurrentUserCanCreate } from '../../crmObjects/hooks/useCurrentUserCanCreate';
import { useCanBETImport } from '../../auth/hooks/useCanBETImport';
import { isTourCurrentlyActive } from 'onboarding-tours/util/activeTour';
import { useIsCrmi0001Variant } from '../../experiments/hooks/useIsCrmi0001Variant';
import { useIsUngatedForIARedesign } from '../../auth/hooks/useIsUngatedForIARedesign';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const useImport = ({
  typeDef,
  hasAllScopes
}) => {
  var _buttonProps$onClick;
  const canBETImport = useCanBETImport();
  const hasImportScope = hasAllScopes('crm-import');
  const hasImportAccess = hasImportScope || !hasImportScope && canBETImport;
  const {
    data: canCreateData,
    loading: isCanCreateLoading,
    error: hasCanCreateRequestError
  } = useCurrentUserCanCreate();

  // Allow the user to create if we encounter an error fetching the permission
  // This will rely on the backend to enforce the permission correctly
  const canCreate = hasCanCreateRequestError ? true : canCreateData;
  const isImportDisabled = !hasImportAccess || !canCreate || isCanCreateLoading;
  // Default to the create disabled tooltip if the user is unable to create objects
  const disabledTooltipKey = !canCreate ? 'createDisabled' : 'importDisabled';
  const {
    limitReached
  } = useObjectLimitAndTotal();
  const {
    buttonProps
  } = useLimitUpgradeButtonProps(IMPORT);
  const {
    closeModal,
    openEmptyStateWelcomeModal,
    openContactDataImportModal
  } = useModalActions();
  const shouldShowContactWelcomeModal = useShouldShowImportEmptyStateModal(
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '"ATTRIBUTION" | "CART" | "COMMUN... Remove this comment to see the full error message
  ObjectTypeFromIds[typeDef.objectTypeId]);
  const isOnboardingTourActive = isTourCurrentlyActive('contacts-import');
  const handleButtonClick = () => {
    if (shouldShowContactWelcomeModal && !isOnboardingTourActive) {
      const onCloseModal = () => {
        trackClickedEmptyStateWelcomeModal({
          objectTypeName: 'IMPORT',
          buttonType: 'close'
        });
        closeModal();
      };
      const onManualSetupClick = () => {
        trackClickedEmptyStateWelcomeModal({
          objectTypeName: ObjectTypeFromIds[typeDef.objectTypeId],
          buttonType: 'manual'
        });
        const redirectUrl = `${links.import()}?via=contact-empty-state`;
        redirectTo(redirectUrl);
      };
      const onGuidedSetupClick = () => {
        trackClickedEmptyStateWelcomeModal({
          objectTypeName: 'IMPORT',
          buttonType: 'guided'
        });
        closeModal();
        openContactDataImportModal();
      };
      openEmptyStateWelcomeModal({
        modalTextType: 'IMPORT',
        onCloseModal,
        onGuidedSetupClick,
        onManualSetupClick
      });
    } else {
      redirectTo(links.import());
    }
  };
  const locked = limitReached && Boolean(buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onClick);
  const handleClick = (_buttonProps$onClick = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onClick) !== null && _buttonProps$onClick !== void 0 ? _buttonProps$onClick : handleButtonClick;
  return {
    isImportDisabled,
    disabledTooltipKey,
    buttonProps,
    handleClick,
    shouldShowContactWelcomeModal,
    limitReached,
    locked
  };
};
const ImportButton = ({
  typeDef,
  hasAllScopes,
  isInDropdown = false
}) => {
  const {
    isImportDisabled,
    disabledTooltipKey,
    buttonProps,
    handleClick,
    shouldShowContactWelcomeModal,
    locked
  } = useImport({
    typeDef,
    hasAllScopes
  });
  const isUngatedForIARedesign = useIsUngatedForIARedesign();
  const ButtonWithToolTip = /*#__PURE__*/_jsx(PermissionTooltip, {
    tooltipKey: disabledTooltipKey,
    tooltipOptions: {
      objectTypeLabel: typeDef.pluralForm
    },
    placement: "bottom",
    disabled: !isImportDisabled,
    children: /*#__PURE__*/_jsxs(Button, {
      "data-test-id": shouldShowContactWelcomeModal ? 'import-button-empty-state' : 'import-button',
      size: "small",
      "data-onboarding": "import-button"
      // Data attribute for coaching tips
      ,
      "data-coaching-tips": "import-button",
      disabled: isImportDisabled,
      href: buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.href,
      onClick: handleClick,
      use: isUngatedForIARedesign && !isInDropdown ? 'primary' : isInDropdown ? 'transparent' : undefined,
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "contentToolbar.import"
      }), locked && /*#__PURE__*/_jsx(LockBadge, {
        "data-test-id": "import-button-lock"
      })]
    })
  });
  if (isInDropdown) {
    return ButtonWithToolTip;
  }
  return /*#__PURE__*/_jsx(Column, {
    marginInlineStart: isUngatedForIARedesign ? '200' : '300',
    children: ButtonWithToolTip
  });
};
export const ImportButtonWrapper = props => {
  const {
    isInExperiment
  } = useIsCrmi0001Variant();
  return isInExperiment ? null : /*#__PURE__*/_jsx(ImportButton, Object.assign({}, props));
};
export default ImportButton;